const sha256 = async (email: string): Promise<string> => {
    // Encode the string as a Uint8Array
    const msgBuffer = new TextEncoder().encode(email);
    
    // Hash the email
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    
    // Convert the ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    
    return hashHex;
}

const setEmailInLocalStorage = async (email: string): Promise<void> => {
    const hashedEmail: string = await sha256(email)
    localStorage.setItem("user_mail_sha256", hashedEmail)
}




export default setEmailInLocalStorage